export default {
  common: {
    table: {
      notfound: 'Sin registros',
    },
    notification: {
      error: 'Error',
      errorMsg: 'Hubo un error en el envío del correo',
      organizationContact: 'Hubo un error creando los contactos de la organización y actualizando la organización, puede ser debido a que los correos esten duplicados',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/common.js